import { CheckCircle2 } from '@carboledger/ui/icons';
import { Typography, TypographyVariants, TypographyColors } from '@carboledger/ui';
import styles from './PasswordRequirementChecklist.module.scss';
import { REGEX } from '@/config/regex.constants';
import { useTranslations } from '@/hooks';

const MIN_PASSWORD_LENGTH = 8;

const RULES = [
  {
    key: 'length',
    labelKey: 'AUTH_PW_REQ_LENGTH',
    test: (value) => value.length >= MIN_PASSWORD_LENGTH,
  },
  {
    key: 'lowercase',
    labelKey: 'AUTH_PW_REQ_LOWERCASE',
    test: (value) => REGEX.HAS_LOWERCASE.test(value),
  },
  {
    key: 'uppercase',
    labelKey: 'AUTH_PW_REQ_UPPERCASE',
    test: (value) => REGEX.HAS_UPPERCASE.test(value),
  },
  {
    key: 'numberOrSymbol',
    labelKey: 'AUTH_PW_REQ_SPECIAL',
    test: (value) => REGEX.HAS_NUMBER_OR_SYMBOL.test(value),
  },
];

/**
 * Props:
 *   password   the current (new) password value being typed
 */
export const PasswordRequirementChecklist = ({ password }) => {
  const t = useTranslations();
  return (
    <ul className={styles.root}>
      {RULES.map(({ key, labelKey, test }) => {
        const met = test(password);
        return (
          <li key={key} className={styles.row}>
            <CheckCircle2
              size={20}
              aria-hidden="true"
              className={met ? styles.iconMet : styles.icon}
            />
            <Typography
              variant={TypographyVariants.label}
              color={met ? TypographyColors.success : TypographyColors.placeholder}
            >
              {t(labelKey)}
            </Typography>
          </li>
        );
      })}
    </ul>
  );
};
